import Vue from 'vue'
import App from './App.vue'
import store from './store'

import ro from 'vee-validate/dist/locale/ro';
import VeeValidate, {Validator} from 'vee-validate';

Vue.use(VeeValidate);
Validator.localize('ro', ro);

var VueCookie = require('vue-cookie');
Vue.use(VueCookie);

Vue.config.productionTip = false

new Vue({
    store,
    render: h => h(App),
}).$mount('#app')
